module.exports = __webpack_public_path__ + "img/iso_menu_v2.15003eef.jpeg";